<template>
  <div class="banner-bottom" :class="bannerActive" :style="myBlockProps.getStyles(visible)">
    <div class="open-banner-button" @click="bannerToggle = !bannerToggle">
      <div :style="titleStyle">{{ recommendationTranslate }}</div>
      <div :style="arrowIconStyle" class="arrow" :class="arrowActive"><span>➤</span></div>
    </div>
    <div class="banner-content">
      <img v-if="image" :src="image" alt="banner image" class="banner-image" />
      <div class="banner-product" v-for="product in recommendedProducts" :key="product.productGuid">
        <div :style="commercialNameStyle" class="banner-product-name">
          <b>{{ translate(product.commercialName) }}</b> <i>{{ productPrice(product) }}</i>
        </div>
        <div :style="commercialDescriptionStyle">
          {{ translate(product.commercialDescription) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ProductProps } from '../models/styleModels/ProductProps';
import Block from './Block.vue';
import { MultiLanguageText, TextProps } from '../models';

export default {
  name: 'banner-recommendation-block',
  extends: Block,
  props: {
    recommendedProducts: { type: Array, default: () => [] },
    recommendationText: { type: Object, required: true },
    image: { type: String },
    productProps: { type: Object, required: true, default: () => ({}) },
    recommendationTextProps: { type: Object, required: true, default: () => ({}) },
    bannerDropTitleProps: { type: Object, required: true, default: () => ({}) },
    iconProps: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      isVisible: true,
      bannerToggle: true
    };
  },
  computed: {
    ...mapGetters(['getProductPrice', 'selectedLanguage']),
    myTitle() {
      return new MultiLanguageText(this.title);
    },
    myRecommendation() {
      return new MultiLanguageText(this.recommendationText);
    },
    myProductProps() {
      return new ProductProps(this.productProps);
    },
    myRecommendationTextProps() {
      return new TextProps(this.recommendationTextProps);
    },
    myBannerDropTitleProps() {
      return new TextProps(this.bannerDropTitleProps);
    },
    myIconProps() {
      return new TextProps(this.iconProps);
    },
    titleTranslate() {
      return this.myTitle.getText(this.selectedLanguage);
    },
    recommendationTranslate() {
      return this.myRecommendation.getText(this.selectedLanguage);
    },
    hasRecommendationText() {
      return this.recommendationTranslate.length > 0;
    },
    popupClasses() {
      return this.hasRecommendationText ? 'popup-padding' : 'popup-no-padding';
    },
    titleStyle() {
      return this.myRecommendationTextProps.getStyles();
    },
    bannerDropTitleStyle() {
      return this.myBannerDropTitleProps.getStyles();
    },
    arrowIconStyle() {
      return this.myIconProps.getStyles();
    },
    commercialNameStyle() {
      return this.myProductProps.popupCommercialNameTextProps.getStyles();
    },
    commercialDescriptionStyle() {
      return this.myProductProps.popupLongCommercialDescriptionTextProps.getStyles();
    },
    imageClasses() {
      if (this.hasRecommendationText && this.recommendedProducts.length > 0) {
        return 'img-small';
      }
      if (this.hasRecommendationText || this.recommendedProducts.length > 0) {
        return 'img-medium';
      }
      return 'img-large';
    },
    bannerActive() {
      return this.bannerToggle ? 'opened' : '';
    },
    arrowActive() {
      return this.bannerToggle ? 'arrow-open' : '';
    }
  },
  methods: {
    translate(item) {
      return (item !== undefined) ? item[this.selectedLanguage] : '';
    },
    productPrice(recommendation) {
      return this.getProductPrice(recommendation.productGuid) || '';
    },
  }
};
</script>
<style>
.banner-bottom {
  height: 168px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: -125px;
  transition: all .5s;
  box-shadow: 0 -13px 15px -3px rgba(0, 0, 0, 0.1);
}

.opened {
  bottom: 0;
}

.arrow {
  background-color: #ffffff;
  border-radius: 100px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(270deg);
}

.arrow-open {
  transform: rotate(90deg);
}

.open-banner-button {
  cursor: pointer;
  padding: 10px 25px 25px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.banner-content {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: row;
}

.banner-image {
  width: fit-content;
  object-fit: contain;
  height: fit-content;
  max-width: 28%;
  max-height: 100px;
  border-radius: 10px;
  margin-right: 10px;
}

@media (max-width: 768px) {
  .banner-image {
    margin-left: 10px;
  }
}

</style>
